import { render, staticRenderFns } from "./accidentReports.vue?vue&type=template&id=b5a8e1c4&scoped=true"
import script from "./accidentReports.vue?vue&type=script&lang=js"
export * from "./accidentReports.vue?vue&type=script&lang=js"
import style0 from "./accidentReports.vue?vue&type=style&index=0&id=b5a8e1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a8e1c4",
  null
  
)

export default component.exports